module.exports = __webpack_public_path__ + "fonts/Lato-Heavy.b0357e42.eot";